import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import paperwork from "./modules/paperwork";
import scheduleTask from "./modules/scheduleTask";
import programme from "./modules/programme";
import echarts from "./modules/echarts";
import plan from "./modules/plan";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    paperwork,
    scheduleTask,
    programme,
    echarts,
    plan,
  },
});

export default store;
